import { MUNICIPAL_PROPERTY_GHG_DERIVED_ID_PREFIX } from "@ark/shared";

export const isMunicipalPropertyGhgDerived = (id: string): boolean => id.startsWith(MUNICIPAL_PROPERTY_GHG_DERIVED_ID_PREFIX);
